import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    requestId: 0,
    pendingMessage: null,
    source: null,
};

const chatQueueSlice = createSlice({
    name: 'chatQueue',
    initialState,
    reducers: {
        requestSend(state, action) {
            const { message, source = 'manual' } = action.payload || {};
            if (!message) return;
            state.requestId += 1;
            state.pendingMessage = message;
            state.source = source;
        },
        consumeSend(state) {
            state.pendingMessage = null;
            state.source = null;
        },
    },
});

export const { requestSend, consumeSend } = chatQueueSlice.actions;
export default chatQueueSlice.reducer;

export const selectChatQueue = (state) => state.chatQueue;
